import { StylingModel } from '../models/style/styling.model';
import { FabModel } from '../models/fab/fab.model';
import { FabButtonModel } from '../models/fab/fab-button.model';

export const /** @type {?} */ FabTemplates = {
  defaultTemplate: {
    property: new FabModel({
      display: true,
      disable: false,
      direction: 'right',
      showButtons: false,
      stayOpened: false,
      trigger: {
        button: {
          label: 'Trigger',
          iconProperty: { name: 'menu' }
        },
        tooltipPosition: 'above'
      },
      actionButtons: [
        {
          button: {
            label: 'Action item',
            iconProperty: { name: 'home' }
          },
          tooltipPosition: 'above'
        }
      ]
    })
  }
}
